module.exports = __webpack_public_path__ + "static/fc-ffeb6e47b686702134097984958efe53.png";